import { render, staticRenderFns } from "./proposal-21-job-board.vue?vue&type=template&id=388b5754"
import script from "./proposal-21-job-board.vue?vue&type=script&lang=js"
export * from "./proposal-21-job-board.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports